import React, {useState} from 'react'

import CssBaseline from '@material-ui/core/CssBaseline'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import {makeStyles} from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

import {forgot} from '../services/api'
import {IForgotRequestParams} from '../interfaces/api'
import {Alert} from '@material-ui/lab'
import {SERVICES} from '../config'
import BootstrapButton from './Common/BootstrapButton'
import BootstrapInput from './Common/BootstrapInput'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.dark,
    },
    paper: {
        height: '100vh',
        paddingTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1)
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}))


export default function Forgot(props: any) {
    const classes = useStyles()

    const [error, setError] = useState<string[]>([])
    const [message, setMessage] = useState<string[]>([])
    const [userInfo, setUserInfo] = useState<IForgotRequestParams>({
        email: '',
        destination: SERVICES.DESTINATION_RULE,
    })

    const handleSubmit = async () => {
        setError([])

        const response = await forgot(userInfo)

        if (response.data.errors) {
            if (response.data.errors.length > 0) {
                setError(
                    response.data.errors.map((item: any, idx: number) => {
                        return <span key={idx}>{item.message}</span>
                    })
                )
            } else {
                setError(response.data.message)
            }
            return
        } else {
            setMessage(response.data.message)
        }
    }

    return (
        <Container component="main" maxWidth="xs" className={classes.root}>
            <CssBaseline/>
            <div className={classes.paper}>
                <form className={classes.form} noValidate>
                    <IconButton aria-label="delete">
                        <Link href="/signin" variant="body2">
                            <ArrowBackIos fontSize="large" />
                        </Link>
                    </IconButton>
                    <Typography align="center">
                        Please enter your email.
                    </Typography>
                    <br/>
                    <Grid item xs={12}>
                        {error && error.length ? (
                            <Alert severity="error">{error}</Alert>
                        ) : (
                            ''
                        )}
                        {message && message.length ? (
                            <Alert severity="success">{message}</Alert>
                        ) : (
                            ''
                        )}
                    </Grid>
                    <br/>
                    {message && message.length ? null:<FormControl fullWidth>
                        <InputLabel style={{color:"#000"}} shrink htmlFor="bootstrap-input">
                            Email Address
                        </InputLabel>
                        <BootstrapInput
                            id="bootstrap-input"
                            value={userInfo.email}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                setUserInfo({
                                    ...userInfo,
                                    email: e.currentTarget.value,
                                })
                            }/>
                    </FormControl>}
                    {message && message.length ? null :
                        <div style={{textAlign: "center", width: "auto", bottom: 0, margin: "20px 0px"}}>
                            <BootstrapButton
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={handleSubmit}>
                                Send
                            </BootstrapButton>
                        </div>
                    }
                </form>
            </div>
        </Container>
    )
}
